<template>
  <div class="ui large modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="list icon"></i>
      {{ $t("course record preview") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img
          src="/images/icons/course_record_1.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui grid">
          <div class="four wide column">
            <div class="ui vertical tabular menu" ref="tabs">
              <a
                class="item"
                :data-tab="'t_' + grpidx"
                v-for="(grp, grpidx) in grouped_students"
                :key="grpidx"
                >{{ grp.group }}</a
              >
            </div>
          </div>
          <div class="twelve wide column">
            <div
              class="ui bottom attached tab segment"
              :data-tab="'t_' + grpidx"
              v-for="(grp, grpidx) in grouped_students"
              :key="grpidx"
            >
              <table class="ui celled definition table" ref="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Carné</th>
                    <th>Nombre</th>
                    <th
                      v-for="(wth, widx) in section.setup.weighting"
                      :key="widx"
                      v-show="wth.is_reporting_stage"
                    >
                      {{ wth.name }}
                    </th>
                    <th>{{ $t("total") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(elm, eidx) in grp.elements" :key="eidx">
                    <td>{{ eidx + 1 }}</td>
                    <td>{{ elm.std_student.student_id_card }}</td>
                    <td>{{ elm.std_student.name }}</td>
                    <td
                      v-for="(wth, widx) in section.setup.weighting"
                      :key="widx"
                      v-show="wth.is_reporting_stage"
                    >
                      {{ getScore(elm.student_id, wth.uuid) }}
                    </td>
                    <td>{{ getTotal(elm.student_id) }}</td>
                  </tr>
                </tbody>
              </table>
              <!-- <generate-report
                :section="section"
                ref="generate_report"
                @generate_report="generate_report"
                :group="grp"
              /> -->
              <h4 class="ui dividing header">
                {{ $t("generate record report") }}
              </h4>
              <div class="ui form">
                <div class="ui grid">
                  <div class="six wide column">
                    <div class="grouped fields">
                      <label>{{ $t("stages to include") }}</label>
                      <div class="field">
                        <div class="ui toggle checkbox">
                          <input type="checkbox" v-model="is_final" />
                          <label>{{ $t("final") }}</label>
                        </div>
                      </div>
                      <div class="field">
                        <div class="ui toggle checkbox">
                          <input type="checkbox" v-model="is_recovery_1" />
                          <label>{{ $t("recovery") }} 1</label>
                        </div>
                      </div>
                      <div class="field">
                        <div class="ui toggle checkbox">
                          <input type="checkbox" v-model="is_recovery_2" />
                          <label>{{ $t("recovery") }} 2</label>
                        </div>
                      </div>
                      <!-- <div
                        class="field"
                        v-for="(wth, widx) in section.setup.weighting"
                        :key="widx"
                      >
                        <div class="ui toggle checkbox">
                          <input
                            type="checkbox"
                            name="example2"
                            v-model="
                              section.setup.weighting[widx].is_reporting_stage
                            "
                          />
                          <label>{{ wth.name }}</label>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="ten wide column">
                    <div class="fields">
                      <div class="field">
                        <label>{{ $t("exam date") }}</label>
                        <div class="ui calendar" ref="exam_date">
                          <div class="ui input left icon">
                            <i class="calendar icon"></i>
                            <input type="text" />
                          </div>
                        </div>
                      </div>
                      <div class="field">
                        <label>{{ $t("generate") }}</label>
                        <div
                          class="ui blue icon labeled button"
                          v-bind:class="{
                            disabled:
                              (!is_final && !is_recovery_1 && !is_recovery_2) ||
                              !exam_date,
                          }"
                          @click="print(grp, grpidx)"
                        >
                          <i class="print icon"></i> {{ $t("generate") }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <pre>{{ grp.elements }}</pre> -->
            </div>
          </div>
        </div>
        <!-- <record-view :template="template" ref="record_view" /> -->
      </div>
    </div>
    <div class="actions">
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import { groupBy, cloneDeep } from "lodash";
// import RecordView from "./RecordView";

export default {
  name: "CourseRecordModalIndex",
  components: {
    /* RecordView */
  },
  props: {},
  computed: {
    grouped_students() {
      let vm = this;
      if (vm.section && vm.section.crs_assignation_students) {
        let grp = groupBy(vm.section.crs_assignation_students, (st) => {
          let obj = {
            branch_id: st.crs_assignation_preinscription.branch_id,
            branch_name: st.crs_assignation_preinscription.std_branch.name,
            career_id: st.crs_assignation_preinscription.career_id,
            career_name: st.crs_assignation_preinscription.std_career.name,
            studying_time_id:
              st.crs_assignation_preinscription.studying_time_id,
            studying_time_name:
              st.crs_assignation_preinscription.std_studying_time.name,
            course_name: vm.section.crs_course.name,
            course_id: vm.section.crs_course.course_id,
            professor_name: vm.section.pfs_professor.setup.name,
            professor_id: vm.section.pfs_professor.professor_id,
            college_number: vm.section.pfs_professor.setup.college_number,
          };
          // console.log(obj, vm.section);
          return JSON.stringify(obj);
          // return `${st.crs_assignation_preinscription.std_branch.name} - ${st.crs_assignation_preinscription.std_career.name} - ${st.crs_assignation_preinscription.std_studying_time.name}`;
        });
        let rarr = Object.keys(grp).map((k) => {
          let obj = JSON.parse(k);
          let name = `${obj.branch_name} - ${obj.career_name} - ${obj.studying_time_name}`;
          return {
            group: name,
            elements: grp[k],
            branch_id: "",
            career_id: "",
            studying_time_id: "",
            obj: obj,
          };
        });
        return rarr;
      } else {
        return [];
      }
    },
  },
  data() {
    return {
      form: undefined,
      section: {},
      template: { css: "", js: "", html: "" },
      is_final: "",
      is_recovery_1: "",
      is_recovery_2: "",
      exam_date: "",
      threshold_score: "",
      record_type: "",
    };
  },
  methods: {
    show_modal(section) {
      let vm = this;

      /**
       * get template
       */
      if (section) {
        /** Get section info */
        local_api(vm, "post", "/course/record/do-get-section", {
          u: section.uuid,
        })
          .then((r) => {
            if (r && r.setup && r.setup.weighting && r.setup.weighting) {
              r.setup.weighting = r.setup.weighting.map((rw) => {
                rw.is_reporting_stage = true;
                return rw;
              });
            }
            vm.section = r;

            setTimeout(() => {
              window
                .jQuery(vm.$refs.tabs)
                .find(".item")
                .tab();

              // vm.$refs.generate_report.map((e) => {
              //   e.stageize();
              // });
            }, 500);
          })
          .catch((err) => {
            error_toast(err);
          });
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            setTimeout(() => {
              window.jQuery(vm.$refs.exam_date).calendar({
                type: "date",
                onChange(value) {
                  vm.exam_date = value;
                },
              });
            }, 500);
          },
          onHide() {},
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          original_url: ["empty", "url"],
        },
      });
    },
    print(group /* index */) {
      let vm = this;

      vm.$alertify.confirm(
        vm.$t("are you sure to generate course record?"),
        function() {
          let stages = vm.section.setup.weighting.filter(
            (l) => l.is_reporting_stage,
          );

          let stdnts = group.elements.map((el) => {
            el.std_student.student_id = el.student_id;
            let obj = { student: el.std_student, stages: [], total: "" };
            stages.map((stg) => {
              obj.stages.push({
                name: stg.name,
                value: vm.getScore(el.student_id, stg.uuid),
              });
            });
            obj.total = vm.getTotal(el.student_id);
            return obj;
          });

          local_api(vm, "post", "/course/record/do-print", {
            b: group.obj.branch_id,
            c: group.obj.career_id,
            r: group.obj.course_id,
            p: group.obj.professor_id,
            t: group.obj.studying_time_id,
            s: vm.section.uuid,
            w: stages,
            g: group.group,
            l: stdnts,
            x: vm.exam_date,
            rt: vm.record_type,
          })
            .then(() => {
              vm.$emit("record_generated");
              // let trgt = document.getElementById("print_element");
              // PHE.printElement(trgt);

              /** Clean it */
              // window
              //   .jQuery("#print_element")
              //   .html('<div id="preview_component"></div>');
            })
            .catch((err) => {
              error_toast(err);
            });

          // let studentsTables = vm.$refs.table;
          // vm.$refs.record_view.init(
          //   group,
          //   stages,
          //   studentsTables[index],
          //   vm.section,
          //   stdnts,
          // );
        },
      );
    },
    generate_report(config) {
      let vm = this;
      vm.$refs.report_render.render(config);
    },
    getScore(student_id, stage_uuid) {
      let vm = this;
      let trgtStudentScore = vm.section.crs_scores.find((sc) => {
        return sc.student_id == student_id;
      });
      if (trgtStudentScore) {
        // return JSON.stringify(trgtStudentScore, null, 2);
        // console.log(trgtStudentScore);
        /** Get stage activities */
        let trgtActivities = trgtStudentScore.setup.filter((ph) => {
          return ph.phase_uuid == stage_uuid;
        });
        if (trgtActivities) {
          let total = trgtActivities.reduce((prev, curr) => {
            return (
              prev +
              (isNaN(curr.score)
                ? 0
                : Number(curr.score) * Number(curr.weighting_percent)) /
                100
            );
          }, 0);
          return total;
        } else return "";
      } else {
        return "";
      }
      // console.log(student_id, stage_uuid);
    },
    getTotal(student_id) {
      let vm = this;
      let trgtStudentScore = vm.section.crs_scores.find((sc) => {
        return sc.student_id == student_id;
      });
      if (trgtStudentScore) {
        // return JSON.stringify(trgtStudentScore, null, 2);
        // console.log(trgtStudentScore);
        /** Get stage activities */
        let weightings = cloneDeep(vm.section.setup.weighting);
        weightings.map((w) => {
          let activities = trgtStudentScore.setup.filter((itm) => {
            // console.log(itm, w);
            return itm.phase_uuid == w.uuid;
          });
          w.activities = activities;
          w.total = activities.reduce((prev, curr) => {
            return (
              prev +
              (isNaN(curr.score)
                ? 0
                : Number(curr.score) * Number(curr.weighting_percent)) /
                100
            );
          }, 0);
        });

        let ttl = weightings.reduce((prev, curr) => {
          return (
            prev +
            (Number(curr.total || 0) * Number(curr.weighting_percent)) / 100
          );
        }, 0);

        return ttl;
      } else {
        return "";
      }
      // console.log(student_id, stage_uuid);
    },
    get_configuration() {
      let vm = this;
      local_api(vm, "post", "/course/record/do-get-configuration")
        .then((r) => {
          // console.log(r);
          if (r) {
            vm.template = r.template;
            if (r.threshold_score) vm.threshold_score = r.threshold_score;
            /**
             * Set stored configuration
             */
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    setWeights(weights) {
      let vm = this;
      if (
        vm.section &&
        vm.section.setup &&
        vm.section.setup.weighting &&
        vm.section.setup.weighting.length
      ) {
        vm.section.setup.weighting.map((w, idx) => {
          let isTrgt = weights.includes(idx);
          w.is_reporting_stage = isTrgt ? true : false;
        });
      }
    },
  },
  mounted() {},
  created() {
    this.get_configuration();
  },
  watch: {
    is_final: function() {
      let vm = this;
      if (this.is_final) {
        /** Set weight of phase 1, phase 2 and phase 3 */
        vm.setWeights([0, 1, 2]);
        vm.record_type = "final";
        this.is_recovery_1 = false;
        this.is_recovery_2 = false;
      }
    },
    is_recovery_1: function() {
      let vm = this;
      if (this.is_recovery_1) {
        /** Set weight of phase 1, phase 2 and recovery 1 */
        vm.setWeights([0, 1, 3]);
        vm.record_type = "recovery_1";
        this.is_final = false;
        this.is_recovery_2 = false;
        // console.log(vm.threshold_score);
      }
    },
    is_recovery_2: function() {
      let vm = this;
      if (this.is_recovery_2) {
        /** Set weight of phase 1, phase 2 and recovery 2 */
        vm.setWeights([0, 1, 4]);
        vm.record_type = "recovery_2";
        this.is_final = false;
        this.is_recovery_1 = false;
        // console.log(vm.threshold_score);
      }
    },
  },
  updated: function() {},
};
</script>
